/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_PatientTaskDTO_ } from '../models/PaginatedDTO_PatientTaskDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenPatientTasksService {
    /**
     * Index
     * @returns PaginatedDTO_PatientTaskDTO_ Successful Response
     * @throws ApiError
     */
    public static indexPatientTasksGet({
        page = 1,
        limit = 10,
        patientId,
        taskId,
        sort
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by patient id
         */
        patientId?: string | null
        /**
         * Filter by task id
         */
        taskId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_PatientTaskDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient_tasks',
            query: {
                page: page,
                limit: limit,
                patient_id: patientId,
                task_id: taskId,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
